import { __assign, __rest } from "tslib";
import React, { useContext, useMemo } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { PureBiData } from '@wix/da-bi/pkg/events';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import PremiumIcon from '@wix/da-ds/pkg/Icons/Premium';
import Button from '../../../Button';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarButton from '../../_partials/items/ActionBarButton';
var DownloadButtonInner = function (_a) {
    var downloadUrl = _a.downloadUrl, dataHook = _a.dataHook, text = _a.text, deviationId = _a.deviationId, isPaidDownload = _a.isPaidDownload, isHighlighted = _a.isHighlighted, showPremiumIcon = _a.showPremiumIcon, disabled = _a.disabled, actionBarButtonProps = __rest(_a, ["downloadUrl", "dataHook", "text", "deviationId", "isPaidDownload", "isHighlighted", "showPremiumIcon", "disabled"]);
    var isMobile = useContext(MobileContext);
    var biData = useMemo(function () {
        return PureBiData({
            evid: 350,
            ispaiddownload: isPaidDownload ? 1 : 0,
            deviationid: deviationId,
        });
    }, [isPaidDownload, deviationId]);
    // the mobile button is a very different design with text and no icon
    return isMobile ? (React.createElement(Button, { view: "b18", href: downloadUrl, target: "_blank", download: true, biData: biData, disabled: disabled }, text)) : (React.createElement(ActionBarButton, __assign({ href: downloadUrl, target: "_blank", download: true, biData: biData, "aria-label": text, "data-hook": dataHook }, actionBarButtonProps),
        React.createElement(ActionBarIcon, { isActive: isHighlighted, icon: showPremiumIcon ? PremiumIcon : DownloadIcon })));
};
DownloadButtonInner.displayName = 'DownloadButtonInner';
export default DownloadButtonInner;
//# sourceMappingURL=DownloadButtonInner.js.map